<template>
    <div align="center">
        <div class="login-container">
            <div class="text-center login-header mb-3">
                <div class="brand">
                    <img :src="logo" style="width: 65px; margin-bottom: 10px" />
                </div>
                <div
                    class="white--text font-weight-400 mb-9"
                    style="font-size: 24px"
                >
                    Skolla Web Admin
                </div>
            </div>
            <div class="login-content">
                <app-alert
                    v-if="this.hasError"
                    v-bind:message="errorMessage"
                    isError="true"
                    v-on:closed="hasError = false"
                ></app-alert>
                <form class="margin-bottom-0" @keyup.enter="handleLogin()">
                    <div class="form-group m-b-20">
                        <input
                            type="text"
                            v-model="email"
                            id="login_email"
                            class="form-control input-lg inverse-mode no-border"
                            placeholder="Masukan Alamat Email"
                            required
                        />
                    </div>
                    <div class="form-group m-b-20">
                        <input
                            type="password"
                            id="login_password"
                            v-model="password"
                            class="form-control input-lg inverse-mode no-border"
                            placeholder="Masukan Password"
                            required
                        />
                    </div>
                    <!-- <div class="checkbox m-b-20">
                <label class="white--text">
                  <input type="checkbox" /> Remember Me
                </label>
              </div> -->
                    <div class="login-buttons">
                        <!-- <button
                  type="button"
                  class="btn btn-success btn-block btn-lg"
                  @click="handleLogin()"
                >
                  Login
                </button> -->
                        <v-btn
                            depressed
                            block
                            dark
                            color="blew"
                            large
                            class="mt-7"
                            :loading="isLoading"
                            @click="handleLogin()"
                        >
                            Login
                        </v-btn>
                    </div>
                </form>
            </div>
        </div>

        <div class="footer-login">&copy; 2023 Skolla. All Rights Reserved</div>
    </div>
</template>

<script>
import Alert from "@/modules/global/components/layout/Alert";
import auth from "@/modules/auth/services/auth.js";
import logo from "@/assets/img/launcher.png";

export default {
    name: "Login",

    components: {
        "app-alert": Alert,
    },

    data: function () {
        return {
            logo: logo,
            errors: [],
            email: "",
            password: "",
            hasError: false,
            errorMessage: "",
            errorTitle: "",
            isLoading: false,
        };
    },

    methods: {
        validateForm: function () {
            this.errors = [];
            if (!this.password) this.errors.push("password");
            if (!this.email) this.errors.push("email");

            if (this.errors.length == 0) return true;

            this.hasError = true;
            this.errorMessage = this.errors.join(" dan ") + " harus diisi";

            return false;
        },

        handleLogin: function () {
            if (this.validateForm()) {
                this.isLoading = true;
                var context = this;
                auth.doLogin(
                    context.email,
                    context.password,
                    function (result) {
                        var userData = result.data;
                        if (result.success) {
                            auth.doValidateToken(
                                userData.token,
                                function (validateTokenResult) {
                                    var appScopes = validateTokenResult.scopes;
                                    context.$ls.set("logged_in", true);
                                    context.$ls.set("token", userData.token);
                                    context.$ls.set(
                                        "refresh_token",
                                        userData.refreshToken
                                    );
                                    context.$ls.set("profiles", {
                                        id: userData.id,
                                        name: userData.name,
                                        firstName: userData.firstName,
                                        lastName: userData.lastName,
                                        email: userData.email,
                                        phone: userData.phoneNumber,
                                        picture: userData.picture,
                                    });

                                    context.isLoading = false;
                                    context.$store.commit(
                                        "auth_authenticated",
                                        appScopes
                                    );
                                    context.$router.push({ name: "Home" });
                                }
                            );
                        } else {
                            context.hasError = true;
                            context.errorMessage = result.message;

                            context.$store.commit("showAlert", {
                                message: "Email dan Password tidak sesuai",
                                submessage:
                                    "Periksa kembali email dan password anda",
                                type: "error",
                            });
                        }
                        context.isLoading = false;
                    }
                );
            }
        },
    },

    mounted: function () {
        if (this.$store.state.auth.loggedIn) {
            this.$router.push("/");
        }
    },
};
</script>

<style>
.theme--light.v-application {
    background: #f3f5f7 !important;
}

.login-container {
    background-color: #2d353c;
    width: 400px !important;
    margin-top: 80px;
    padding: 30px 40px 50px 40px;
    border-radius: 10px !important;
    box-shadow: rgba(3, 18, 26, 0.523) 0px 2px 15px !important;
}

.footer-login {
    margin-top: 40px;
    text-align: center;
    padding: 10px;
    font-size: 12px;
    bottom: 0;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// Login.vue?78f93921